import React from 'react';

// Components
import Link from 'components/common/Link';
import Text from 'components/common/Text';

// Libs
import Translation from 'libs/Translation';

const InnerLinks = ({ specialty, city }) => {
    
    return ( 
    <div className='inner-links'>
        <Link 
            to={`/search/specialty/${specialty}/city/${city}`}
        >
            <Text
                className="label"
                tag="h3"
            >
                عنوان مطلب لینک ویکلینیک
            </Text>
        </Link>
    </div>
    )
}

export default InnerLinks;
